import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { PermissionResourceService } from "../../../service/resources/permission/permissionResource.service";

export interface IMenuDetails {
    code: string;
    name: string;
    exist: boolean;
    selected: boolean;
    permission?: string;
    minWidth?: string;
}

@Component({
    selector: 'menu-details',
    templateUrl: './menu-details.component.html',
    styleUrls: ['./menu-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuDetailsComponent implements OnInit {
    @Input()
    public items: IMenuDetails[];

    @Input()
    public canUse: boolean = true;

    @Output()
    public readonly onChangeTab: EventEmitter<string> = new EventEmitter();

    constructor(private readonly permissionService: PermissionResourceService) {
    }

    public changeTab(tabCode: string): void {
        if (this.canUse) {
            this.onChangeTab.emit(tabCode);
        }
    }

    public ngOnInit(): void {
        this.items.forEach((item: IMenuDetails) => {
            if (item.permission) {
                this.permissionService.hasPermission(item.permission)
                    .subscribe((hasPermission: boolean) => {
                        item.exist = hasPermission;
                    });
            }
        });
    }
}
